import { Fragment } from 'react';

import { rage } from '~/rage';

import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { StyledBgCircle } from './Background.styled';

const Background: React.FC = () => (
	<Fragment>
		{rage.config.isStub() && (
			<BgPlaceholder $type={PlaceholderType.VehicleMoveNight} />
		)}
		<StyledBgCircle $position={'left'} />
		<StyledBgCircle $position={'right'} />
	</Fragment>
);

export { Background };
